import { styled } from '@mui/material';

export const TitleStyled = styled('span', {
  shouldForwardProp: (prop) =>
    prop !== 'maxLines' &&
    prop !== 'headlineNews' &&
    prop !== 'isClickable' &&
    prop !== 'overflowNotHidden',
})(({ theme, maxLines, headlineNews, isClickable, overflowNotHidden }) => {
  const maxLinesStyles = () => {
    if (maxLines)
      return {
        overflow: !overflowNotHidden && 'hidden',
        display: '-webkit-box',
        WebkitLineClamp: maxLines,
        lineClamp: maxLines,
        WebkitBoxOrient: 'vertical',
      };

    return null;
  };

  return {
    fontSize: '18px',
    textTransform: 'uppercase',
    color: theme.palette.colors.mainFocused,
    cursor: isClickable ? 'pointer' : 'auto',
    fontWeight: 'bold',

    '&:hover': {
      textDecoration: isClickable ? 'underline' : 'none',
    },
    ...maxLinesStyles(),

    [theme.breakpoints.up('lg')]: {
      fontSize: headlineNews ? '18px' : '16px',
    },
  };
});
